import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '@environments/environment';
import { Observable, BehaviorSubject, shareReplay } from 'rxjs';
import { Stage } from '@shared/model/stage';

const CACHE_SIZE=1;
@Injectable({
  providedIn: 'root'
})
export class StageService {
  
  private myStagesCache$!: Observable<Stage[]>;

  private isStoreDirty:boolean=false;
  private allStagesSource=new BehaviorSubject<Stage[]>([]);
  allStagesStore=this.allStagesSource.asObservable();

  constructor(private http: HttpClient) { }

  getStages():Observable<Stage[]>{
    return this.http.get<Stage[]>(`${environment.serviceApi}/stages`);
  }
  getMyStages():Observable<Stage[]>{
    return this.http.get<Stage[]>(`${environment.serviceApi}/stages/mine`);
  }
  get myStages()
  {
    if (!this.myStagesCache$) {
      this.myStagesCache$ = this.getMyStages().pipe(
        shareReplay(CACHE_SIZE)
      );
    }

    return this.myStagesCache$;
  }
  AddStage(stage:Stage):Observable<Stage>{
    this.isStoreDirty=true;
    return this.http.post<Stage>(`${environment.serviceApi}/stages`,stage);
  }
  EditStage(id:string|number,stage:Stage):Observable<Stage>{
    this.isStoreDirty=true;
    return this.http.put<Stage>(`${environment.serviceApi}/stages/${id}`,stage);
  }
  toggleActive(stage:Stage):Observable<Stage>{
    this.isStoreDirty=true;
    return this.http.put<Stage>(`${environment.serviceApi}/stages/${stage.id}/changestatus`,stage);
  }
  deleteStage(stage:Stage):Observable<Boolean>{
    this.isStoreDirty=true;
    return this.http.delete<boolean>(`${environment.serviceApi}/stages/${stage.id}`);
  }
  /**
   * Get the stage infor with attribute list and users
   */
  getStageInfo(id:string|number|null):Observable<Stage>{
    return this.http.get<Stage>(`${environment.serviceApi}/stages/${id}`);
  }
  loadStore(refresh:boolean=false){
    if (this.allStagesSource.getValue().length<=0 || refresh || this.isStoreDirty){
      this.getStages().subscribe(stages=>this.allStagesSource.next(stages));
    }else
    {
      this.allStagesSource.next(this.allStagesSource.value);
    }
  }
  /**
   * 
   * @param stageId Add Attribute to given stage
   * @param attributeId 
   * @param isEditable 
   */
  addStageAttribute(stageId:number,attributeId:number|String,isEditable:boolean){
    return this.http.post<Stage>(`${environment.serviceApi}/stages/${stageId}/addattribute`,{id:attributeId,isEditable:isEditable});
  }
  /**
   * Change stage-attribute relationship
   * @param stageAttributeId 
   * @param isEditable 
   */
  updateStageAttribute(stageAttributeId:number|String,isEditable:boolean,isRequired:boolean){
    return this.http.put<Stage>(`${environment.serviceApi}/stages/attribute/${stageAttributeId}`,{stageAttributeId:stageAttributeId,isEditable:isEditable,isRequired:isRequired});
  }
  /**
   * remove stage-attribute relationship
   * @param stageAttributeId 
   */
  deleteStageAttribute(stageAttributeId:number|String):Observable<Boolean>{
    return this.http.delete<boolean>(`${environment.serviceApi}/stages/attribute/${stageAttributeId}`);
  }
  /**
   * Add user to Stage
   * @param stageId 
   * @param userName 
   */
  addStageUser(stageId:number,userName:string){
    return this.http.post<Stage>(`${environment.serviceApi}/stages/${stageId}/adduser`,{username:userName});
  }
  deleteStageUser(stageId:number|String,userName:string):Observable<Boolean>{
    return this.http.delete<boolean>(`${environment.serviceApi}/stages/${stageId}/user/${userName}`);
  }
  initDefaults() {
    return this.http.post<Stage>(`${environment.serviceApi}/startup/`,null);
  }
}
